import React from 'react';
import type { IconShape } from '../types/portfolio';
type StackedIconProps = {
  shape: IconShape;
  layers?: number;
  className?: string;
};
const shapes: Record<IconShape, string> = {
  octagon: 'M15 4h18l11 11v18L33 44H15L4 33V15z',
  hexagon: 'M24 3l18.2 10.5v21L24 45 5.8 34.5v-21z',
  square: 'M6 6h36v36H6z',
  diamond: 'M24 3l21 21-21 21L3 24z',
  circle: 'M4 24a20 20 0 1 0 40 0a20 20 0 1 0 -40 0',
  chamfer: 'M14 5h29v28l-10 10H5V14z'
};
export function StackedIcon({
  shape,
  layers = 4,
  className = ''
}: StackedIconProps) {
  return <svg viewBox="-1 -1 66 50" className={className} aria-hidden="true" data-id="element-534" data-mp="4qrp5hi73usf">
      {Array.from({
      length: layers
    }).map((_, i) => {
      const isFront = i === layers - 1;
      return <path key={i} d={shapes[shape]} transform={`translate(${i * 5} 0)`} fill="#ffffff" stroke={isFront ? 'rgb(var(--accent))' : '#9a9aa4'} strokeWidth={1} strokeLinejoin="round" vectorEffect="non-scaling-stroke" data-id="element-535" data-mp="3rxaljc0xn9jo" data-mpi={i} />;
    })}
    </svg>;
}